import { Component, Inject, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { ToastrService } from "ngx-toastr";
import { Message } from "src/app/core/class/message";
import { AutoEnterpriseService } from "src/app/core/services/auto-enterprise.service";
import { CommonService } from "src/app/core/services/common.service";
import { DocumentService } from "src/app/core/services/document.service";

@Component({
    selector: 'app-manage-contract-share-partner-moha',
    templateUrl: './manage-contract-share-partner-moha.component.html',
    styleUrls: ['./manage-contract-share-partner-moha.component.scss']
})
export class ListManageContractSharePartnerComponent implements OnInit {
    @BlockUI() blockUI: NgBlockUI;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private message: Message,
        public dialogRef: MatDialogRef<ListManageContractSharePartnerComponent>,
        private documentService: DocumentService,
        private toastr: ToastrService,
        public commonService: CommonService,
        private dialog: MatDialog,
        public autoEnterpriseService: AutoEnterpriseService,

    ) {

    }
    ngOnInit() {
        this.documentService.getListPartnerSharedById(this.data.id).subscribe(res => {
            if (res.success) {
                this.RECORD_SHARE_PARTNER = res.data.map(item => {
                    return {
                      ...item,
                      email: item.receiveEmail,
                      name: item.receiveName,
                      phone: item.receivePhone,
                    }
                  })
            }
        })
    }

    filteredPartyOptions: any = []
    timeOutQueryServer: any;
    inputPartyValue: string = ''
    nzCheckLoadingParty2 = false
    RECORD_SHARE_PARTNER = []
    isChange: boolean = false;
    onChangePartySignSearch($event: any): void {
        this.filteredPartyOptions = [];
        if ($event.inputType.includes('insert') || $event.inputType.includes('delete')) {
            if (this.timeOutQueryServer) {
                clearTimeout(this.timeOutQueryServer);
            }
            this.timeOutQueryServer = setTimeout(() => {
                if (this.inputPartyValue.trim().length > 0) {
                    this.nzCheckLoadingParty2 = true;
                    this.autoEnterpriseService.fetchAuto(this.inputPartyValue.trim())
                        .then(result => {
                            // console.log('record party sign result', result);

                            this.filteredPartyOptions = [];
                            if (result) {
                                for (const item of result) {
                                    if (!item.isCreatedSide) {
                                        if (!this.checkExistedParty(item.enterpriseId, item.customerId)) {        // Nếu chưa được chọn thì cũng mới hiển thị cho chọn
                                            // Chống lặp bản ghi trong danh sách suggest
                                            const existedList = this.filteredPartyOptions.filter((e) => {
                                                return e.enterpriseId === item.enterpriseId;
                                            });
                                            // if (existedList.length === 0) {
                                            this.filteredPartyOptions.push(item);
                                            // }
                                        }
                                    }
                                }
                            }
                            // this.filteredPartyOptions = result;
                        }).finally(() => {
                            this.nzCheckLoadingParty2 = false;
                        });
                } else {
                    this.inputPartyValue = '';
                }
            }, 500);

        }
    }
    autocompletePartySelected($event: any, model: any) {
        if ($event.isUserInput) {
            this.isChange = true
            if (!this.checkExistedParty(model.enterpriseId, model.customerId)) {
                this.RECORD_SHARE_PARTNER = [
                    ...this.RECORD_SHARE_PARTNER,
                    {
                        enterpriseId: model.enterpriseId,
                        customerId: model.customerId,
                        email: model.email,
                        name: model.name,
                        phone: model.phone,
                        permission: 'FILE'
                    }
                ];



                this.inputPartyValue = '';
                this.filteredPartyOptions = [];

            } else {
                this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_party_apostrophe_duplicate'), model.name));
            }
        }
    }
    checkExistedParty(enterpriseId: string, customerId: string) {
        const existedList = this.RECORD_SHARE_PARTNER.filter((e) => {
            return enterpriseId ? e.enterpriseId === enterpriseId : e.customerId === customerId;
        });

        return (existedList.length > 0);
    }
    onClickDeleteElementRecordParty(enterpriseId: any, customerId: any): void {
        this.isChange = true
        if (enterpriseId && enterpriseId.length > 0) {
            this.RECORD_SHARE_PARTNER = this.RECORD_SHARE_PARTNER.filter(d => d.enterpriseId !== enterpriseId);
        } else {
            this.RECORD_SHARE_PARTNER = this.RECORD_SHARE_PARTNER.filter(d => d.customerId !== customerId);
        }
    }
    close(){
        this.dialogRef.close()
    }

    save(){
        this.documentService.updateListPartnerShared({contractId: this.data.id, contractSharePartners: this.RECORD_SHARE_PARTNER}).subscribe(res => {
            if(res.success){
                this.toastr.success(this.message.getMessage('contract_share_partner.share_contract_success'))
                this.close()
            } else {
                this.toastr.error(res.message)
            }
        })
    }
}